import { createFileRoute } from "@tanstack/react-router"
import { LiveEventOverview } from "@/features/live-events-admin/overview/LiveEventOverview"

export const Route = createFileRoute("/live-events/$eventId/")({
	component: OverviewPage,
})

function OverviewPage() {
	const { eventId } = Route.useParams()
	return <LiveEventOverview eventId={eventId} />
}
